<template>
    <span class="dk-usp" :class="cssClasses">
        <span class="dk-usp__title" :class="titleCssClasses">
            {{ title }}
        </span>
        <span v-if="subtitle" class="dk-usp__subtitle tw-block tw-mt-10 tw-text-xl tw-leading-lg tw-text-center">
            {{ subtitle }}
        </span>
    </span>
</template>

<script>
export default {
    name: 'DkUSPOverlay',
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            default: null,
        },
        hasHover: {
            type: Boolean,
            default: false,
        },
        isInSearchCard: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        cssClasses() {
            const cssClasses = [
                'tw-absolute',
                'tw-top-0',
                'tw-left-0',
                'tw-h-full',
                'tw-w-full',
                'tw-bg-slate-900',
                'tw-bg-opacity-[0.72]',
                'tw-text-white',
            ];

            if (this.isInSearchCard) {
                cssClasses.push('tw-p-4', 'tw-pr-10', 'lg:tw-pr-6');
            } else {
                cssClasses.push('tw-px-8', 'tw-py-10', 'tw-flex', 'tw-flex-col', 'tw-justify-center');
            }

            if (!this.hasHover) {
                cssClasses.push('tw-pointer-events-none');
            } else {
                cssClasses.push('hover:tw-bg-opacity-[0.56] tw-transition-all');
            }

            return cssClasses;
        },
        titleCssClasses() {
            const cssClasses = ['tw-block', 'tw-font-bitter'];

            if (this.isInSearchCard) {
                cssClasses.push('tw-text-xl', 'lg:tw-text-2xl', 'tw-leading-lg');
            } else {
                cssClasses.push('tw-text-[38px]', 'tw-leading-[46px]', 'tw-text-center');
            }

            return cssClasses;
        },
    },
};
</script>
